import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonos = [{
  num: 'B1',
  title: 'Plantilla de Contrato de Remodelación Listo para Usar',
  desc: 'Un documento legal base adaptado para proteger tu dinero, definir plazos de entrega y evitar reclamos injustificados de los clientes.',
  value: '$9.700',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Contrato de remodelación firmado'
}, {
  num: 'B2',
  title: 'Portadas Profesionales en Canva para Presupuestos',
  desc: 'Plantillas editables de nivel corporativo para que tus cotizaciones entren por los ojos del cliente desde el primer segundo.',
  value: '$9.700',
  image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Diseño de portadas profesionales en Canva'
}, {
  num: 'B3',
  title: 'Guía de Seguimiento por WhatsApp para Contratistas y Diseñadores',
  desc: 'Copiar y pegar. Los guiones exactos de mensajes de texto para enviar a tus clientes potenciales y cerrar el trato sin sonar desesperado.',
  value: '$9.700',
  image: 'https://images.unsplash.com/photo-1611746872915-64382b5c76da?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Mensajes profesionales por WhatsApp'
}];
export function Bonos() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-yellow-50 border-y border-yellow-100" data-id="element-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-6 sm:mb-10" data-id="element-18">
          <div className="inline-flex items-center justify-center p-2 sm:p-3 bg-brand-accent/20 rounded-full mb-3 sm:mb-5" data-id="element-19">
            <Gift className="w-5 h-5 sm:w-9 sm:h-9 text-brand-accentHover" data-id="element-20" />
          </div>
          <h2 className="text-xl sm:text-3xl md:text-5xl font-extrabold mb-2 text-[#2E5BA9]" data-id="element-21">
            INCLUIDOS GRATIS: 3 Bonos Estratégicos
          </h2>
          <p className="text-xs sm:text-lg text-gray-600 font-medium" data-id="element-22">
            Sin costo extra — Incluidos en tu compra hoy
          </p>
        </div>

        {/* Compact horizontal rows */}
        <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8" data-id="element-23">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} whileHover={{
          x: 4
        }} className="flex items-stretch bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 overflow-hidden relative" data-id="element-24">
              {/* Image */}
              <div className="relative w-20 sm:w-32 flex-shrink-0 bg-gray-100 overflow-hidden" data-id="element-25">
                <img src={bono.image} alt={bono.alt} loading="lazy" decoding="async" width="240" height="240" className="absolute inset-0 w-full h-full object-cover" data-id="element-26" />
                <div className="absolute top-1 left-1 bg-brand-accent text-brand-dark font-black text-[10px] sm:text-xs px-1.5 py-0.5 rounded" data-id="element-27">
                  {bono.num}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 p-3 sm:p-5 flex flex-col justify-center min-w-0" data-id="element-28">
                <h3 className="text-sm sm:text-lg font-bold text-brand-dark leading-tight mb-1 sm:mb-2" data-id="element-29">
                  {bono.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-snug line-clamp-2 sm:line-clamp-none" data-id="element-30">
                  {bono.desc}
                </p>
                <p className="text-[10px] sm:text-xs text-gray-400 line-through mt-1 sm:mt-2" data-id="element-31">
                  Valorado en {bono.value}
                </p>
              </div>

              {/* GRATIS badge */}
              <div className="flex items-center justify-center bg-brand-accent text-brand-dark font-black px-2 sm:px-4 text-[10px] sm:text-sm tracking-wide writing-vertical" data-id="element-32">
                <span className="rotate-180" style={{
              writingMode: 'vertical-rl'
            }} data-id="element-33">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-dark text-white text-center py-3 sm:py-5 rounded-xl shadow-xl" data-id="element-34">
          <p className="text-sm sm:text-2xl font-black tracking-wide" data-id="element-35">
            VALOR TOTAL DE LOS BONOS:{' '}
            <span className="text-brand-accent line-through opacity-80" data-id="element-36">
              $29.100
            </span>{' '}
            — GRATIS HOY
          </p>
        </motion.div>
      </div>
    </section>;
}